import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// @tcc
import { getMessage } from 'util/locale';
import { Dropdown } from '@tcc/crate';

// components
import HtmlTextWithTooltip from 'html-text/HtmlTextWithTooltip';
import Explainer from './Explainer';

// util
import { createProductOptions } from 'products/productOptionsUtil';

// constants
import { MIN_HYBRID_PRODUCT_SEARCH_LENGTH } from 'constants/products';
import { getActiveCropId } from 'current/currentSelectors';
import { useSelector } from 'react-redux';

const baseString = 'vra-brand-and-hybrid';
const BrandAndHybrid = ({
  currentProductId,
  seedProducts,
  isReviewScriptStep,
  onChangeSearchQuery,
  onSelectProduct,
  validationResult
}) => {
  const cropId = useSelector(getActiveCropId);
  if (isReviewScriptStep) { return null; }

  const isInvalid = validationResult ? validationResult.isInvalid : false;

  const classString = classNames({
    [`${baseString}`]: true,
    'vra-planting-plan-form__fieldset': true,
    'isInvalid': isInvalid
  });

  const onSelect = (value, id) => {
    const selectedProduct = seedProducts.find(product => product.id === id);
    if (selectedProduct) {
      onSelectProduct({
        productId:selectedProduct.id, 
        productName:selectedProduct.name, 
        brand:selectedProduct.brand});
    }
  };

  const tooltip = {
    titleKey: `tooltip-text__tested__header.${cropId}`,
    contentKey: `tooltip-text__tested__body.${cropId}`,
    triggerElementId: 'tested'
  };

  const canDisplayIcon = true;

  // this function is called when input changes,
  // intended to retrieve dropdown options from somewhere (in this case an API call) and pass them to onOptionsLoaded
  const loadOptions = (input, onOptionsLoaded) => {
    // once the search API call has finished, receiveOptions is called with the results

    const receiveOptions = (products) => {
      const normalOptions = createProductOptions(products, canDisplayIcon)
      .sort((a, b) => a.value.localeCompare(b.value));

      const isSearchAsyncSearch = input.length >= MIN_HYBRID_PRODUCT_SEARCH_LENGTH;

      // the API call doesn't return data until 3 characters are entered
      onOptionsLoaded(isSearchAsyncSearch ? normalOptions : []); // this function gives the options to the crate dropdown once they are loaded
    };

    // this triggers the API call
    onChangeSearchQuery({ fragment: input, receiveOptions });
  };
  let currentProductName = '';
  if (seedProducts && currentProductId) {
    const selectedProduct = seedProducts.find(product => product.id === currentProductId);
    currentProductName = selectedProduct ? selectedProduct.name : '';
  }
  return (
    <section className={classString}>
      <div className='vra-planting-plan-form__inputs-wrapper'>
        <Dropdown
          label={getMessage('corn-product')}
          loadOptions={loadOptions}
          placeholder={getMessage('placeholder-text__start-typing')}
          setValue={onSelect}
          testId={'vra-planting-plan-form__brand-and-hybrid'}
          type='AsyncDropdown'
          value={currentProductName}
        />
      </div>
      <Explainer isVisible={!isReviewScriptStep}>
        <HtmlTextWithTooltip
          messageKey={`text__advanced-script__brand-and-hybrid.${cropId}`}
          tooltip={tooltip}
        />
      </Explainer>
    </section>
  );
};
BrandAndHybrid.propTypes = {
  currentProductId: propTypes.string.isRequired,
  isReviewScriptStep: propTypes.bool.isRequired,
  onChangeSearchQuery: propTypes.func.isRequired,
  onSelectProduct: propTypes.func.isRequired,
  seedProducts: propTypes.array.isRequired,
  validationResult: propTypes.object
};
export default BrandAndHybrid;
